import React from 'react';

const svgProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: '1.45',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': 'true',
  focusable: 'false',
};

const none = { fill: 'none' };

export const IconHamburger = () => (
  <svg {...svgProps} width="26" height="26">
    <path d="M4 7h16M4 12h16M4 17h16" {...none} />
  </svg>
);

export const IconSpeech = () => (
  <svg {...svgProps}>
    <path
      {...none}
      d="M6.2 5.2h11.6A2.8 2.8 0 0 1 20.6 8v6.2a2.8 2.8 0 0 1-2.8 2.8h-4.1L8.4 20.4v-3.4H6.2A2.8 2.8 0 0 1 3.4 14.2V8A2.8 2.8 0 0 1 6.2 5.2Z"
    />
  </svg>
);

export const IconHeart = () => (
  <svg {...svgProps}>
    <path
      {...none}
      d="M12 19.4S4.8 15 3.2 11.2C2 8.6 3.4 6 6.4 5.7c1.7-.2 3.2.8 3.9 2.2.7-1.4 2.2-2.4 3.9-2.2 3 .3 4.4 2.9 3.2 5.5C19.2 15 12 19.4 12 19.4Z"
    />
  </svg>
);

export const IconLotus = () => (
  <svg {...svgProps}>
    <path
      {...none}
      d="M12 20c-2.7-2.5-4.2-5.2-4.2-7.6 0-2.1 1.7-3.5 4.2-3.5s4.2 1.4 4.2 3.5c0 2.4-1.5 5.1-4.2 7.6Z"
    />
    <path {...none} d="M8.2 16.8C5 15 3.2 12.6 3 10.2c-.2-1.6 1.1-2.6 2.5-2.1 1.3.4 2.6 1.9 3.4 3.6" />
    <path {...none} d="M15.8 16.8c3.2-1.8 5-4.2 5.2-6.6.2-1.6-1.1-2.6-2.5-2.1-1.3.4-2.6 1.9-3.4 3.6" />
    <path {...none} d="M12 12.6c-.2-2.8.3-5.4 1.7-7.1.8-1 2.1-.9 2.3.4.3 1.5-.2 3.4-1.2 5" />
    <path {...none} d="M12 12.6c.2-2.8-.3-5.4-1.7-7.1-.8-1-2.1-.9-2.3.4-.3 1.5.2 3.4 1.2 5" />
  </svg>
);

export const IconDollar = () => (
  <svg {...svgProps}>
    <path
      {...none}
      d="M12 3.6v16.8M16 8c-.7-1.6-2-2.4-4-2.4-2.3 0-4 1.3-4 3.1 0 4 8 1.8 8 5.8 0 1.9-1.8 3.3-4.2 3.3-2.2 0-3.7-1-4.4-2.6"
    />
  </svg>
);

export const IconCalendar = () => (
  <svg {...svgProps}>
    <rect x="3.8" y="5.4" width="16.4" height="14.8" rx="2.2" {...none} />
    <path {...none} d="M7.6 3.6v3.4M16.4 3.6v3.4M3.8 10h16.4" />
  </svg>
);

export const IconPeople = () => (
  <svg {...svgProps}>
    <circle cx="9" cy="8" r="2.6" {...none} />
    <path {...none} d="M4.6 18.6c.6-3.2 2.6-4.8 4.4-4.8s3.8 1.6 4.4 4.8" />
    <circle cx="16.1" cy="8.4" r="2.2" {...none} />
    <path {...none} d="M13.4 18.6c.5-2.6 2-4 3.6-4 1.5 0 2.8 1.1 3.4 3.4" />
  </svg>
);

/**
 * Front-facing navy open book traced from Sam's final Learn More JPG:
 * three short rays above the spine, rounded page tops that meet in a Y,
 * vertical sides, bottom feet, and a center point at the binding.
 */
export const IconBook = () => (
  <svg
    viewBox="-1.2 -1.2 26.4 26.4"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path {...none} d="M8.15 2.05 9.95 4.55" />
    <path {...none} d="M12 .35V4.25" />
    <path {...none} d="M15.85 2.05 14.05 4.55" />
    <path
      {...none}
      d="M12 8.75C10.2 6.9 7.45 6.4 5.25 6.55 3.05 6.7 1.2 7.9.7 9.5v10.7c0 1.35.5 2.2 1.55 2.35 2.75.4 5.95-1 9.75 1.2 3.8-2.2 7-1.8 9.75-1.2 1.05-.15 1.55-1 1.55-2.35V9.5c-.5-1.6-2.35-2.8-4.55-2.95-2.2-.15-4.95.35-6.75 2.2Z"
    />
    <path {...none} d="M12 8.75V23.7" />
  </svg>
);

export const IconScriptHeart = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      d="M12 20s-7-4.4-8.9-8.1C1.6 9.2 2.9 6.2 6 5.6c1.8-.3 3.4.5 4.2 2 .8-1.5 2.4-2.3 4.2-2 3.1.6 4.4 3.6 2.9 6.3C19 15.6 12 20 12 20Z"
      fill="currentColor"
    />
  </svg>
);

/** Outlined script heart for the homepage footer (REF_featured_footer_EXACT). */
export const IconOutlinedHeart = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.55"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M12 20s-7-4.4-8.9-8.1C1.6 9.2 2.9 6.2 6 5.6c1.8-.3 3.4.5 4.2 2 .8-1.5 2.4-2.3 4.2-2 3.1.6 4.4 3.6 2.9 6.3C19 15.6 12 20 12 20Z"
      fill="none"
    />
  </svg>
);
